<template>
  <div
    class="relative px-6 pt-4 pb-4 text-white rounded-md shadow-xl transform hover:shadow-lg hover:scale-95 transition-shadow transition-transform transition duration-300 group"
    :class="`bg-${colorBase}-500`"
  >
    <header class="mb-5 flex items-center">
      <span
        :class="`text-${colorBase}-800`"
        class="text-xs uppercase font-semibold"
      >{{ title }}</span>
    </header>

    <!-- opacity-0 group-hover:opacity-100 -->
    <div
      class="absolute right-0 bottom-0 mr-5 mb-6 font-semibold flex items-center"
      :class="`text-${colorBase}-200`"
    >
      <div class="mr-3 flex items-center">
        <img
          class="w-4 mr-1 opacity-30"
          src="@/assets/images/icon-apple.svg"
        >
        <span>{{ numberWithCommas(iosCount) }}</span>
      </div>
      <div class="flex items-center">
        <img
          class="w-4 mr-1 opacity-30"
          src="@/assets/images/icon-android.svg"
        >
        <span>{{ numberWithCommas(androidCount) }}</span>
      </div>
    </div>

    <template v-if="loading">
      <a-spin class="block" />
    </template>
    <template v-else-if="error">
      <div class="text-red">
        error
      </div>
    </template>
    <template v-else>
      <span class="block font-bold text-4xl">
        {{ numberWithCommas(count) }}
      </span>
    </template>
  </div>
</template>

<script>
import { numberWithCommas } from '@/lib/utils'

export default {
  props: {
    colorBase: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    count: {
      type: [String, Number],
      required: true
    },
    iosCount: {
      type: [String, Number],
      default: null
    },
    androidCount: {
      type: [String, Number],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Object, Error],
      default: null
    }
  },
  methods: {
    numberWithCommas
  }
}
</script>